export default __webpack_public_path__ + "static/media/H.e5a10a19.svg";